import { ICreateOrder } from "../models/modal.model";
import { BuyerModel } from "../models/orders/buyer.model";
import { OrderModel } from "../models/orders/order.model";
import { OwnerModel } from "../models/orders/owner.model";
import { setUpAPI } from "../utils/auth.utils";
import {base64Decode, shortOwnerType, xorDecrypt} from '../utils/global.utils'


const { REACT_APP_API_URL } = process.env;

export const newOrder = async (order: ICreateOrder) => {
  const url = `${REACT_APP_API_URL}/v1/api/client/order/create`;
  const owners: OwnerModel[] = [];
  const buyers: BuyerModel[] = [];

  const orderData = {
    "agency": {
      "agencyId": order.orgId,
      "agencyName": "",
      "agencyPortalId": ""
    },
    "state": {
      "stateCode": order.state,
      "stateName": order.stateName
    },
    "underwriter": "string",
    "agencyOrderId": order.customerOrderId,
    "correlationId": order.customerOrderId,
    "source": "Client Portal",
    "orderType": order.orderType,
    "properties": [
      {
        "address": {
          "addressLine1": order.address,
          "addressLine2": order.address,
          "county": order.county,
          "municipality": order.municipality,
          "countyCode": `${order.countyCode}`,
          "DistrictCode": "",
          "city": order.city,
          "zip": order.zipCode
        },
        "block": order.block,
        "lot": order.lot,
        "qual": order.qualifier,
        "parcelId": order.parcelId,
        "transactionType": order.transaction_TypeId,
        "propertyType": order.property_typeId,
        "policyType": order.policy_typeId,
        "purchasePrice": "0.0",
        "owner": [
          ...order.owners.map(item => ({
            "firstName": item.firstName,
            "middleName": item.middleName,
            "lastName": item.lastName,
            "type": shortOwnerType(item.ownerTypeId)
          })),
        ]
      }
    ],
    "shortSale": false,
    "deedInLieu": false,
    "processingType": "Std",
    "buyer": [
      ...order.buyers.map(item => ({
        "firstName": item.firstName,
        "middleName": item.middleName,
        "lastName": item.lastName,
        "type": shortOwnerType(item.ownerTypeId)
      }))
    ],
    "mortgageLender": {
      "name": "",
      "clause": "",
      "loanAmount": ""
    },
    "loanAmount": 0.0,
    "searchLength": order.searchLength,
    "dueDate": order.duedate,
    "notes": order.comments
  }

  const response = await setUpAPI(url, orderData, 'POST').catch((err) => {
    return err;
  });

  const body = await response.json();
  return body;
}

export const getOrderList = async (status:string|undefined) => {
  let finalStatus = '';
  if(status) {
    finalStatus = status !== 'all' ? status : '';
  }
  const url = `${REACT_APP_API_URL}/v1/services/orders?status=${finalStatus}`;
  const response = await setUpAPI(url, undefined, 'GET').catch((err) => {return err;});
  const body = await response.json();
  
  if(body.success && body.success.msg) {
    return body.success.msg;
  } else {
    return body;
  }
}

export const getOrderDetails = async(orderId:string) => { 

  const decodeOid = xorDecrypt(base64Decode(orderId));
  const url = `${REACT_APP_API_URL}/v1/services/order/${decodeOid}`;

  const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err});
  
  const body = await response.json();

  if(body && body.success && body.success.msg[0]) {
    const newOrder:OrderModel = body.success.msg[0];
    return newOrder;
  } else if(body && body.error) {
    return body.error;
  }
  
}

export const getPricingDetails = async(transactionId : number) => 
  {
    //transactionId:string
    const url =  `${REACT_APP_API_URL}/v1/services/getPricingDetails?transactionId=${transactionId}` 
    const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err}); 
    const body = await response.json();
    return body

  }

export const getDocument = async(documentPath: string) => {
  const url = `${REACT_APP_API_URL}/v1/services/invoker/docgen/pdf2string`;
  var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
          "documents": [documentPath],
          "authKey": "d68c908ad8a31c3963f42181f932458461e5a379"
      })
    };
  
    const response = await fetch(url, requestOptions).catch((err) => {return err;});
    const body = await response.json();
    return body;
}

 export const getStatus = (processingQueue:string|undefined, status:string|undefined) => {
    var currentStatus = "Unknown";
    var description = "";

    if (status === "Withdrawn") {
      currentStatus = "Cancelled";
      description = "Cancelled";
    } else if (processingQueue === "Complete") {
      currentStatus = "Delivered";
      description = "Delivered";
    } else if (status === "Wait") {
      currentStatus = "Waiting";
      description = "Client Action Required";
    } else if (processingQueue === "Delivery") {
      if (status === "Hold") {
        currentStatus = "On Hold";
        description = "Waiting for Ancillary Search(es)";
      } else if (status === "" || isNullorUndefined(status)) {
        currentStatus = "Delivery";
        description = "Delivery";
      }
    } else if (processingQueue === "Admin") {
      if (status === "Hold") {
        currentStatus = "On Hold";
        description = "Additional Search(es) Requested";
      } else if (status === "" || isNullorUndefined(status)) {
        currentStatus = "Active";
        description = "Examining";
      }
    } else if (processingQueue === "Order") {
      if (status === "" || isNullorUndefined(status)) {
        currentStatus = "Active";
        description = "Retrieving County Search";
      }
    } else if (processingQueue === "Reader") {
      if (status === "" || isNullorUndefined(status)) {
        currentStatus = "Active";
        description = "Examining";
      } else if (status === "Hold") {
        currentStatus = "Active";
        description = "Retrieving County Search";
      }
    } else if (processingQueue === "QC") {
      if (status === "" || isNullorUndefined(status)) {
        currentStatus = "Active";
        description = "Examining";
      } else if (status === "Hold") {
        currentStatus = "Active";
        description = "Examining";
      }
    } else {
      currentStatus = "Unknown";
      description = "Unknown";
    }

    return { status: currentStatus, description: description };
};

export const localStatus = (processingQueue:string|undefined, status:string|undefined) => {
  let currentStatus = "unknown";

  if((status === "Hold" && (processingQueue === 'Reader' || processingQueue === 'reader')) || status === "Wait" || status === "Active") {
    if(processingQueue === "Complete") {
      currentStatus = "done"
    } else if (processingQueue === "Order"){
      currentStatus = "Received"
    }
    else{
      currentStatus = "progress"
    }
  } else if(status === "Withdrawn") {
    currentStatus = "ignore"
  } else {
    currentStatus = "Received";
  }

  return { status: currentStatus };
}



export const filterOrders = async (searchText:string, status:string|undefined = '') => {
  const url = `${REACT_APP_API_URL}/v1/services/search?filenumber=${searchText}&status=${status}`;

  const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err});
  
  const body = await response.json();

  if(body && body.success && body.success.msg) {
    return body.success.msg;
  } else if(body && body.error) {
    throw body.error;
  }
}


  function isNullorUndefined(value:any) {
    return value === null || value === undefined;
  }

  export const getSearcherCompany = async() => {
    const url = `${REACT_APP_API_URL}/v1/services/orgSearcherCompanies`;
    const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err});
    const body = await response.json();
    return body;
  }

  export const updateNotes = async (id:number, note:string, commenter:string|undefined) => {
    const url = `${REACT_APP_API_URL}/v1/services/comments/update`;
    let order = {};
  
    if(id && note) {
      order = {
        "order": {
          "order": {
            "transaction": {
              "id": id,
              "comments": note,
              "commenter": commenter ? commenter : ''
            }
          }
        }
      }
    }
  
    const response = await setUpAPI(url, order, 'PUT').catch((err) => {return err;});
    const body = await response.json();
    return body.success.msg
  }
  export const rushButton = async(userEmail: string,clientOrder:string,searchCompany:number,AEStransactionID:number) => {
    const url = `${REACT_APP_API_URL}/v1/services/notes/special-request`;
    let requestOptions = {};
    
    /*
     requestOptions = {
          "button_id" : "Rush",
          "order_id" : clientOrderId,
          "order":{"note":{"transactionId":AEStransactionID,"userID":userEmail,"read":false}}
        };
        */
        requestOptions =  {
          "button_id" : "Rush",
          "order_id" : clientOrder,
          "search_company_id": searchCompany,
          "order":{"note":{"transactionId":AEStransactionID,"userEmail":userEmail,"read":false}}
      }
        

      const response = await setUpAPI(url, requestOptions,'POST').catch((err) => {return err;});
      const body = await response.json();
      return body.success.msg;
    
  }

  export const updateSearchCompany = async(orderId: number, searchCompany: number) => {
    const url = `${REACT_APP_API_URL}/v1/services/searcherCompany/order/${orderId}`;
    let assignData = {} 
    if(searchCompany){
      assignData = {
        "searchCompanyId": searchCompany
      }
    }
    const response = await setUpAPI(url, assignData, 'POST').catch((err) => {
      return err;
    });
    
    const body = await response.json();

  return body.message;

}


export const updateSpecialRequest = async (buttonType:string,apiDatatoSend:any,messageText:string) => {  
  const url = `${REACT_APP_API_URL}/v1/services/notes/special-request`;
  let requestOptions = {};

  requestOptions = {
    "button_id": buttonType,
    "order_id": apiDatatoSend.fileNumber,
    "appended_note": messageText,
    "order": {
      "note": {
        "transactionId": apiDatatoSend.transactionId,
        "userEmail": apiDatatoSend.email,
        "read": false
      }
    }
  }


  const response = await setUpAPI(url, requestOptions, 'POST').catch((err) => { return err; });
  const body = await response.json();

  
  return body;
}

export const getOrderReportDetails = async (reportingOrgId:number, api_token: string,startDate:string,endDate:string,status:string) => {
  const url = `${REACT_APP_API_URL}/v1/services/getReportDetails?reportingOrgId=${reportingOrgId}&transactionStartDate=${startDate}&transactionEndDate=${endDate}&status=${status}`;
  let requestOptions = {
    "reportingOrgId": reportingOrgId,
    "transactionStartDate": startDate,
    'transactionEndDate': endDate,
    "status": status
  };
  const response = await setUpAPI(url, requestOptions, 'POST').catch((err) => {return err;});
  const body = await response.json();
  return body;
}
export const getStates = async () => {
  const url = `${REACT_APP_API_URL}/v1/services/getActiveStatesCounties`;
  const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err});
  const body = await response.json();
  return body;
}

export const getMunicipalities = async (stateId: any, countyId: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/getMunicipalitiesForStateAndCounty?stateId=${stateId}&countyId=${countyId}`;
  const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err});
  const body = await response.json();
  return body;
}

export const getOrgProfiles = async() => {
  const url = `${REACT_APP_API_URL}/v1/services/orgProfiles`;
  const response = await setUpAPI(url,undefined, 'GET').catch(err => {return err});
  const body = await response.json();
  return body;
}

export const getPropertyPolicyTypes = async() => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const response = await fetch(`${apiUrl}/v1/services/getPropertyPolicyTransactionTypes`, {
    method: 'GET',
  });
  return response.json();
}

export const getStateProducts = async (stateCode: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/getStateProducts?state_code=${stateCode}`;
  const response = await setUpAPI(url, undefined, 'GET').catch((err) => {
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const getOrgProducts = async (orgId: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/productsByOrgId?reportingOrgId=${orgId}`;
  const response = await setUpAPI(url, undefined, 'GET').catch((err) => {
    return err;
  });

  const body = await response.json();
  return body;
}

export const getVendorAssignment = async () => {
  const url = `${REACT_APP_API_URL}/v1/services/getVendorAssignment`;
  const response = await setUpAPI(url, undefined, 'GET').catch((err) => {
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const submitVendors = async (vendor: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/addVendor`;
  let requestOptions = {};
  if(vendor) {
    requestOptions = {
      ...vendor,
      counties: (vendor.counties && vendor.counties.length !== 0) ? vendor.counties.join(",") : ""
    }
  }
  const response = await setUpAPI(url, requestOptions, 'POST').catch((err) => {
    console.log(err);
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const updateVendors = async (vendor: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/updateVendor`;
  let requestOptions = {};
  if(vendor) {
    requestOptions = {
      ...vendor,
      counties: (vendor.counties && vendor.counties.length !== 0) ? vendor.counties.join(",") : ""
    }
  }
  const response = await setUpAPI(url, requestOptions, 'PUT').catch((err) => {
    console.log(err);
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const deleteVendor = async (id: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/removeVendor`;
  let requestOptions = {};
  if(id) {
    requestOptions = {
      id: id
    }
  }
  const response = await setUpAPI(url, requestOptions, 'DELETE').catch((err) => {
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const downloadVendorTemplate = async () => {
  const url = `${REACT_APP_API_URL}/v1/services/generateVendorTemplate`;
  const response = await setUpAPI(url, undefined, 'GET').catch((err) => {
    return err;
  });
  const body = await response.json();
  return body;
}

export const bulkUploadVendors = async (vendors: any[]) => {
  const url = `${REACT_APP_API_URL}/v1/services/bulkAddVendors`;
  const requestOptions = {
    "vendors": vendors
  }
  const response = await setUpAPI(url, requestOptions, 'POST').catch((err) => {
    console.log(err);
    return err;
  });

  const body = await response.json();
  return body;
}

export const submitPayments = async (payments: any[]) => {
  const url = `${REACT_APP_API_URL}/v1/services/addPayments`;
  let requestOptions = {};
  if(payments && payments.length !== 0) {
    requestOptions = {
      "payments": payments.map((item: any, index: any) => ({
        "transactionId": item
      }))
    }
  }
  const response = await setUpAPI(url, requestOptions, 'POST').catch((err) => {
    console.log(err);
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const updatePaymentStatus = async (transactionId: any, amountPaid: any, paymentMethod: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/addPayments`;
  let requestOptions = {};
  if(transactionId && amountPaid && paymentMethod) {
    requestOptions = {
      "payments": [
        {
          "transactionId": transactionId,
          "amount_paid": amountPaid,
          "payment_method": paymentMethod
        }
      ]
    }
  }
  const response = await setUpAPI(url, requestOptions, 'PUT').catch((err) => {
    console.log(err);
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const getPaymentDetails = async (transactionId: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/getClientPaymentDetails?transactionId=${transactionId}`;
  const response = await setUpAPI(url, undefined, 'GET').catch((err) => {
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const markDeleted = async (transactionId: any) => {
  const url = `${REACT_APP_API_URL}/v1/services/deletePayment?transactionId=${transactionId}`;
  const response = await setUpAPI(url, undefined, 'DELETE').catch((err) => {
    return err;
  });
  
  const body = await response.json();

  return body;
}

export const getOrderHistory = async(address:string,state:string,county:string,customerOrderId:string,reportingOrgId:string) => {
  const url = `${REACT_APP_API_URL}/v1/services/orderHistoryDetails?address=${encodeURIComponent(address)}&state=${encodeURIComponent(state)}&county=${encodeURIComponent(county)}&customerOrderId=${encodeURIComponent(customerOrderId)}&reportingOrgId=${encodeURIComponent(reportingOrgId)}`;
  
  try {
    const response = await setUpAPI(url, undefined, 'GET');
    const body = await response.json();
    return body;
  } catch (err) {
    return err;
  }
}

export const getUploadedFileDetails = async (searchCompanyId: number) => {
  const url = `${REACT_APP_API_URL}/v1/services/getEOFileDetailsBasedonSearchCompany?searchcompanyId=${searchCompanyId}`

  try {
    const response = await setUpAPI(url, undefined, 'GET')
    const body = await response.json()
    return body
  } catch (err) {
    return err
  }
}

export const downloadDocument = async (searchCompanyId: number, fileName: string) => {
  // Encode the searchCompanyId and fileName to handle special characters
  const encodedId = encodeURIComponent(searchCompanyId)
  const encodedFileName = encodeURIComponent(fileName)
  const url = `${REACT_APP_API_URL}/v1/services/getPreSignedUrl/download?searchcompanyId=${encodedId}&filename=${encodedFileName}`

  try {
    const response = await setUpAPI(url, undefined, 'GET')
    const body = await response.json()
    return body
  } catch (err) {
    return err
  }
}
export const addCoverRundown = async (api_token: string, payload: any) => {
  const {REACT_APP_API_URL} = process.env;
  let myHeaders = new Headers();
  myHeaders.append("Authorization",api_token);
  myHeaders.append("Content-Type", "application/json");
  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify(payload)
  }
  const response = await fetch(`${REACT_APP_API_URL}/v2/api/order/createCoverRundowns`, requestOptions).catch(error => {return (error)});
  let body = null;
  if(response) {
    body = await response.json();
  }
  return body;
}

export const filterOrdersTable = async (payload: any) => {
  const { status, transaction_searchType, transaction_searchCompanyId, transaction_searchCompanyName, transaction_state, tgOrder_propertyCounty, transaction_rush, transaction_currentDueDate } = payload
  const url = `${REACT_APP_API_URL}/v1/services/orders/filter?status=${status}&transaction_searchType=${transaction_searchType}&transaction_searchCompanyId=${transaction_searchCompanyId}&transaction_searchCompanyName=${transaction_searchCompanyName}&tgOrder_propertyCounty=${tgOrder_propertyCounty}&transaction_state=${transaction_state}&transaction_rush=${transaction_rush}&transaction_currentDueDate=${transaction_currentDueDate}`;

  try {
    const response = await setUpAPI(url, undefined, 'GET');
    const body = await response.json();
    return body;
  } catch (err) {
    return err;
  }
}